 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		53: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		53: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app." + ({"7":"DeprecatedStyles","14":"EnhancedStyles","15":"app-components-Workflow-WorkflowContainer","16":"app-components-bibs-BibPage-BibPageContainer","17":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","18":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","19":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","20":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","21":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","22":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","23":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","24":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","25":"app-components-bibs-subpages-CommentPage-CommentPageContainer","26":"app-components-bibs-subpages-MarcPage-MarcPageContainer","27":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","28":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","29":"app-components-bibs-subpages-VideoPage-VideoPageContainer","30":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","31":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","32":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","33":"app-components-borrowing-fines-Fines-FinesContainer","34":"app-components-borrowing-fines-GlobalPaymentsPage","35":"app-components-borrowing-holds-Holds-HoldsContainer","36":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","37":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","38":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","39":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","40":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","41":"app-components-events-EventsSearchPage-EventsSearchPageContainer","42":"app-components-events-MyEventsPage-MyEventsPageContainer","43":"app-components-info-apps-UnregisterPage","44":"app-components-list-ListPageContainer","45":"app-components-locations-LocationsPage-LocationsPage","46":"app-components-search-Search-SearchContainer","47":"app-components-search-SearchPrintList-SearchPrintListContainer","48":"app-components-settings-account-UnregisterPage","49":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","50":"app-components-shelves-Shelf-ShelfContainer","51":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","52":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"6a3e367169bbac1bf0dc","1":"c8e57232586f37ed3cbb","2":"e3a01f0afb7370b53265","3":"48bd19ea8ad19899170b","4":"459b1bbfe97aeaca5661","5":"150a9a58fa2b13974757","6":"492d1f80a1a1d84d0fd1","7":"aea74f0da34e3293cea0","8":"c627c968d44ccb9ae7e8","9":"197cca3583d9e9c22545","10":"1afa1b4493911ce41a73","11":"f83cbd8ec95fe718e550","12":"9de2116490a934faaf37","13":"a69578659b0057f52abc","14":"9edc5b918a1172f42c9e","15":"269198b683c2ae5734f9","16":"19741f38147bd6087266","17":"93e0f85462fc6f8c5592","18":"f92000b2cd1b0879a1da","19":"20c97fe76ef5d68c24e5","20":"181513a58c8157e29543","21":"f9407256629a6fe9081c","22":"7541a0e4a9c3f389a62e","23":"d999d0cfc993847133ca","24":"b684ca755a66c6a34353","25":"0a6d62923b60c987d559","26":"7ea58d4cdc2d8b692951","27":"c2feb63e6b3222abc105","28":"b11a1ddc741755af7a0c","29":"2267b61f81af4c9cc205","30":"3c2b96b9b86743b0b9f0","31":"ad626ff7e7deab197f4b","32":"12201f8bb13be656b2fe","33":"15ca1e0ff0d0710a60a2","34":"ae0aaceeda46aeef85cc","35":"e0ac2ed07b55da88072f","36":"8c60bd84ca8c9f7ac955","37":"a3fddad53f923efe64e1","38":"05c18c63c90d5f998b19","39":"d0c4b6385109e944dbda","40":"45fc04841d6f44f20e0b","41":"04318ba506437522eb15","42":"4ecc0782e00b6c851f5e","43":"a729f0f96eeb374b35bb","44":"065da6f7ee411e385b73","45":"20e81372c51c5843cca4","46":"8c455022caf3015bc0ec","47":"4f20bf398635d52a49a7","48":"746a028096a536ab88d1","49":"9e345cd948b9a953822f","50":"c675e042fdd4aa431087","51":"7830c9f78a0f6564f319","52":"4230275ccc97b0a96367","54":"66eb1700052ec9923da3","55":"dc5b59fc84a08a396c92","56":"53581819c2fbea3944c5","57":"927b007bb439782ca1b5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"54":1,"55":1,"56":1,"57":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app." + ({"7":"DeprecatedStyles","14":"EnhancedStyles","15":"app-components-Workflow-WorkflowContainer","16":"app-components-bibs-BibPage-BibPageContainer","17":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","18":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","19":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","20":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","21":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","22":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","23":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","24":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","25":"app-components-bibs-subpages-CommentPage-CommentPageContainer","26":"app-components-bibs-subpages-MarcPage-MarcPageContainer","27":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","28":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","29":"app-components-bibs-subpages-VideoPage-VideoPageContainer","30":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","31":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","32":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","33":"app-components-borrowing-fines-Fines-FinesContainer","34":"app-components-borrowing-fines-GlobalPaymentsPage","35":"app-components-borrowing-holds-Holds-HoldsContainer","36":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","37":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","38":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","39":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","40":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","41":"app-components-events-EventsSearchPage-EventsSearchPageContainer","42":"app-components-events-MyEventsPage-MyEventsPageContainer","43":"app-components-info-apps-UnregisterPage","44":"app-components-list-ListPageContainer","45":"app-components-locations-LocationsPage-LocationsPage","46":"app-components-search-Search-SearchContainer","47":"app-components-search-SearchPrintList-SearchPrintListContainer","48":"app-components-settings-account-UnregisterPage","49":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","50":"app-components-shelves-Shelf-ShelfContainer","51":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","52":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"6a3e367169bbac1bf0dc","1":"c8e57232586f37ed3cbb","2":"e3a01f0afb7370b53265","3":"48bd19ea8ad19899170b","4":"459b1bbfe97aeaca5661","5":"150a9a58fa2b13974757","6":"492d1f80a1a1d84d0fd1","7":"aea74f0da34e3293cea0","8":"c627c968d44ccb9ae7e8","9":"197cca3583d9e9c22545","10":"1afa1b4493911ce41a73","11":"f83cbd8ec95fe718e550","12":"9de2116490a934faaf37","13":"a69578659b0057f52abc","14":"9edc5b918a1172f42c9e","15":"269198b683c2ae5734f9","16":"19741f38147bd6087266","17":"93e0f85462fc6f8c5592","18":"f92000b2cd1b0879a1da","19":"20c97fe76ef5d68c24e5","20":"181513a58c8157e29543","21":"f9407256629a6fe9081c","22":"7541a0e4a9c3f389a62e","23":"d999d0cfc993847133ca","24":"b684ca755a66c6a34353","25":"0a6d62923b60c987d559","26":"7ea58d4cdc2d8b692951","27":"c2feb63e6b3222abc105","28":"b11a1ddc741755af7a0c","29":"2267b61f81af4c9cc205","30":"3c2b96b9b86743b0b9f0","31":"ad626ff7e7deab197f4b","32":"12201f8bb13be656b2fe","33":"15ca1e0ff0d0710a60a2","34":"ae0aaceeda46aeef85cc","35":"e0ac2ed07b55da88072f","36":"8c60bd84ca8c9f7ac955","37":"a3fddad53f923efe64e1","38":"05c18c63c90d5f998b19","39":"d0c4b6385109e944dbda","40":"45fc04841d6f44f20e0b","41":"04318ba506437522eb15","42":"4ecc0782e00b6c851f5e","43":"a729f0f96eeb374b35bb","44":"065da6f7ee411e385b73","45":"20e81372c51c5843cca4","46":"8c455022caf3015bc0ec","47":"4f20bf398635d52a49a7","48":"746a028096a536ab88d1","49":"9e345cd948b9a953822f","50":"c675e042fdd4aa431087","51":"7830c9f78a0f6564f319","52":"4230275ccc97b0a96367","54":"66eb1700052ec9923da3","55":"dc5b59fc84a08a396c92","56":"53581819c2fbea3944c5","57":"927b007bb439782ca1b5"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-nerf.bibliocommons.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2377);
